(window as any).__Zone_disable_FileReader = true;
